"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var middleware_1 = require("./middleware");
exports.createEventsUouBiMiddleware = function (events) {
    return middleware_1.createBiMiddleware({
        bi: helpers_1.createIframeAppBiLogger(events.endpoint),
        eventMap: events.eventMap,
        extendEvent: helpers_1.extendEventsUouEvent,
    });
};
exports.createEventsUsersBiMiddleware = function (events) {
    return middleware_1.createBiMiddleware({
        bi: helpers_1.createWebBiLogger(events.endpoint),
        eventMap: events.eventMap,
        extendEvent: helpers_1.extendEventsUsersEvent,
    });
};
exports.createUouBiMiddlewareWithBiParams = function (params, events) {
    return middleware_1.createBiMiddlewareWithBiParams({
        bi: helpers_1.createUoUBiLoggerWithBiParams(params),
        eventMap: events.eventMap,
        biParams: params,
    });
};
exports.createUsersBiMiddlewareWithBiParams = function (params, events) {
    return middleware_1.createBiMiddlewareWithBiParams({
        bi: helpers_1.createUserBiLoggerWithBiParams(params),
        eventMap: events.eventMap,
        biParams: params,
    });
};
